/**
 * 4-Corner Model constants — shared between web and mobile.
 */

export const CORNERS = [
  { id: 'corner-technical', label: 'Technical / Tactical', colorHex: '#C0392B', icon: '\u26BD', sortOrder: 1 },
  { id: 'corner-physical', label: 'Physical', colorHex: '#27AE60', icon: '\u26A1', sortOrder: 2 },
  { id: 'corner-psych', label: 'Psychological', colorHex: '#F39C12', icon: '\uD83E\uDDE0', sortOrder: 3 },
  { id: 'corner-social', label: 'Social', colorHex: '#2980B9', icon: '\uD83E\uDD1D', sortOrder: 4 },
] as const;

export const CORNER_COLORS: Record<string, string> = {
  'corner-technical': '#C0392B',
  'corner-physical': '#27AE60',
  'corner-psych': '#F39C12',
  'corner-social': '#2980B9',
};
